require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/core-js/library/fn/object/get-prototype-of.js
// module id = 332
// module chunks = 0